import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CoreConfigService} from '@core/services/config.service';
import {Subject} from 'rxjs';

import {takeUntil} from 'rxjs/operators';
import {CoreConfig} from '../../../../../@core/types';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit, OnDestroy {
  public coreConfig: CoreConfig;
  public redirectUrl: string = '';
  // Private
  private _unsubscribeAll: Subject<void>;
  public error: string;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(
    private _coreConfigService: CoreConfigService, 
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {
    this._unsubscribeAll = new Subject<void>();

    // Configure the layout
    this._coreConfigService.setConfig({
      layout: {
        navbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        menu: {
          hidden: true
        },  
        customizer: false,
        enableLocalStorage: false
      }
    });
  }


  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.redirectUrl = this._router.url;
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });

    this.error = this._activatedRoute.snapshot.queryParams?.error ?? '';
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
